import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { IconCheck } from '@sm/wds-icons';

const ComparisonTableFeatureCell = ({ a11yHeaders, checked = false, text = null, className = '' }) => {
  let cell = text;

  // Provided text will supercede the checked property
  if (!text) {
    cell = (
      <span className="wds-type--primary">
        {checked && <IconCheck aria-hidden="true" data-testid="ComparisonTableFeatureCell__Check" />}
        <span className="sm-comparison-table__sr-text">{checked ? 'available' : 'not available'}</span>
      </span>
    );
  }

  return (
    <td
      className={classnames('sm-comparison-table__cell', 'wds-type--center', className, {
        'sm-comparison-table__cell--checked': checked,
      })}
      data-testid="ComparisonTableFeatureCell"
      headers={a11yHeaders.join(' ')}
    >
      {cell}
    </td>
  );
};

ComparisonTableFeatureCell.propTypes = {
  a11yHeaders: PropTypes.arrayOf(PropTypes.string).isRequired,
  checked: PropTypes.bool,
  text: PropTypes.string,
  className: PropTypes.string,
};

ComparisonTableFeatureCell.defaultProps = {
  checked: false,
  text: '',
  className: '',
};

export default ComparisonTableFeatureCell;
